import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../utils/Loader';
import Select from 'react-select';
import { fetchCashbackReport, setReportsFilters } from '../../action';
import DateSelect from '../utils/DateSelect';
import moment from 'moment';
import SortButton from '../utils/SortButton';
import { isEmpty } from 'lodash';
import { formatNumberWithSpaces, parseNumToFixed } from '../../utils/common';
import { fetchCities, fetchFilials } from '../../action/handbook';
import { utils, writeFileXLSX } from 'xlsx';
import ErrorContainer from '../utils/ErrorContainer';
import MultiSelect from '../utils/MultiSelect';

const styles = {
    loading: {
        minHeight: '200px',
        display: 'flex',
        justifyContent: 'center'
    }
};

function FirstLvlRow ({item, firstLvl, color='#d5d4ff61', marginLeft = '0px' }) {
    const [ showFirstLvl, setShowFirstLvl ] = useState(false);
    const renderFirstLvl = firstLvl && firstLvl !== 'none';

    const handleClick = () => {
        if (!renderFirstLvl) return;
        setShowFirstLvl(!showFirstLvl);
    }

    return (
        <>
        <tr onClick={handleClick} className='kt-datatable__row' style={renderFirstLvl ? { cursor: 'pointer', backgroundColor: color } : { backgroundColor: color }}>
            {renderFirstLvl && <td className='kt-datatable__cell' style={{ width: '12px' }}><i className={`kt-menu__ver-arrow la la-angle-${showFirstLvl ? 'up' : 'down'}`} style={{ fontSize: '0.8rem' }}/></td>}
            <td className='kt-datatable__cell' style={{ width: 'auto'}}><span style={renderFirstLvl ? { marginLeft: '15px' } : { marginLeft: marginLeft }}>{item.name}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(item.count) || 0}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(item.totalSum) || 0}</span></td>
        </tr>
        {renderFirstLvl && showFirstLvl && 
            Object.entries(item.detailData).map(([key, item]) => <FirstLvlRow item={item} firstLvl={null} color='#bbbaff61' marginLeft='60px' />)
        }
        </>
    )
}

function ResultRow ({items}) {
    const result = Object.values(items).reduce((acc, item) => {
        acc.totalSum += item.totalSum || 0;
        acc.count += item.count || 0;
        return acc;
    }, { totalSum: 0, count: 0 });
    return (
        <tr className='kt-datatable__row' style={{ backgroundColor: '#cfcfcf61'}}>
            <td className='kt-datatable__cell' style={{ width: 'auto'}}><span>ИТОГО</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(result.count) || 0}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(result.totalSum) || 0}</span></td>
        </tr>
    )
}

function ItemRow ({item, firstLvl, secondLvl}) {
    const [ showFirstLvl, setShowFirstLvl ] = useState(false);

    if (item.name === 'Не определен') {
        if ((!item.count || item.count === 0) && (!item.totalSum || item.totalSum === 0)) return null;
    }

    const renderFirstLvl = firstLvl && firstLvl !== 'none' && !isEmpty(item.detailData);
    const renderSecondLvl = !renderFirstLvl && secondLvl && secondLvl !== 'none' && !isEmpty(item.detailData);

    const handleClick = () => {
        if (!renderFirstLvl && !renderSecondLvl) return;
        setShowFirstLvl(!showFirstLvl);
    }

    return (
        <>
        <tr onClick={handleClick} className='kt-datatable__row' style={(renderFirstLvl || renderSecondLvl) ? { cursor: 'pointer' } : {}}>
            {(renderFirstLvl || renderSecondLvl) && <td className='kt-datatable__cell' style={{ width: '12px'}}><i className={`kt-menu__ver-arrow la la-angle-${showFirstLvl ? 'up' : 'down'}`} style={{ fontSize: '0.8rem' }}/></td>}
            <td className='kt-datatable__cell' style={{ width: 'auto'}}><span>{item.name}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(item.count) || 0}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(item.totalSum) || 0}</span></td>
        </tr>
        {(renderFirstLvl || renderSecondLvl) && showFirstLvl && 
            Object.entries(item.detailData).map(([key, item]) => <FirstLvlRow item={item} firstLvl={renderSecondLvl ? null : secondLvl} marginLeft='45px'/>)
        }
        </>
    )
}

const renderAdressPoint = (item) => {
    if (!item) return 'Не определен';
    return `${item.city.name ? item.city.name : '---'}, ${item.street}, ${item.house}`;
};

const firstLvlOptions = [
    { label: 'Нет', value: 'none' },
    { label: 'День', value: 'day', notRender: [ 'year' ]},
    { label: 'Неделя', value: 'week', notRender: [ 'day', 'week' ]},
    { label: 'Месяц', value: 'month', notRender: [ 'day', 'week' ]},
];

const secondLvlOptions = [
    {label: 'Нет', value: 'none'},
    {label: 'Филиал', value: 'points'},
];

export default function Cashback() {
    const data = useSelector(state => state.reports.cashback);
    const points = useSelector(state => state.handbook.filials);
    const pointsCount = useSelector(state => state.handbook.count.filials);
    const cities = useSelector(state => state.handbook.cities);
    const citiesCount = useSelector(state => state.handbook.count.cities);
    const pointLoading = useSelector(state => state.loaders.filials);
    const citiesLoading = useSelector(state => state.loaders.cities);

    const { result, filters, loading } = data;
    const [ _sort, setSort ] = useState({ field: 'name', sort: 'ASC'});
    const [ renderFilters, setRenderFilters ] = useState(filters);

    const dispatch = useDispatch();

    const [ renderDetail, setRenderDetail ] = useState({
        firstLvl: {label: 'Нет', value: 'none'},
        secondLvl: { label: 'Нет', value: 'none' },
    });

    useEffect(() => {
        const getData = async () => {
            if (!pointLoading && (isEmpty(points) || points.length < pointsCount)) await dispatch(fetchFilials(null, true));
            if ((isEmpty(cities) || cities.length < citiesCount)) await dispatch(fetchCities(true));
        };
        
        getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleClickSort = (newFiled) => {
        const { field, sort } = _sort;
        if (newFiled === field) {
            const newSort = sort === 'DESC' ? 'ASC' : 'DESC';
            setSort({field: _sort.field, sort: newSort});
        } else {
            setSort({field: newFiled, sort: 'ASC'});
        }
    }

    const onChangeDateSelect = (e) => {
        if (e && e.min && e.max) {
            const updated = { ...filters};
            updated.created_at_gte = e.min;
            updated.created_at_lte = e.max;
            dispatch(setReportsFilters('cashback', updated));
        }
    }

    const setDetail = (field) => (data) => {
        const updated = { ...renderDetail, [field]: data};
        setRenderDetail(updated);
    }

    const setFilters = (field) => (data) => {
        const updated = { ...filters, [field]: data};
        dispatch(setReportsFilters('cashback', updated));
    }

    const onSearch = () => {
        dispatch(fetchCashbackReport('cashback'));
        setRenderFilters(filters);
    }

    const getSecondLvlOptions = () => {
        const date_gte = moment(filters.created_at_gte);
        const date_lte = moment(filters.created_at_lte);
        const diff = date_lte.diff(date_gte, 'days');
        let value = null;
        if (diff === 0) value = 'day';
        if (diff === 6) value = 'week';
        if (diff > 6 && diff < 180) value = 'month';
        if (diff >= 180) value = 'year';

        return value ? firstLvlOptions.filter((item) => !item.notRender || !item.notRender.includes(value)) : firstLvlOptions;
    }

    const isDisabledSearch = () => {
        if (loading) return true;
        if (!filters.lvls || filters.lvls.length === 0) return true;
        if (!filters.cities || filters.cities.length === 0) return true;
        return false;        
    }
    
    const onExport = () => {
        const firstLvl = renderDetail.firstLvl.value;
        const secondLvl = renderDetail.secondLvl.value;
        const data = getGroupedData();
        const isRenderFirstLvl = firstLvl && firstLvl !== 'none' && !isEmpty(data);
        const isRenderSecondLvl = secondLvl && secondLvl !== 'none' && !isEmpty(data);

        const exportData = Object.entries(data).sort(([aKey, a], [bKey, b]) => {
            const { field, sort } = _sort;
            const aField = a[field || 'name'];
            const bField = b[field || 'name'];
            if (sort === 'DESC') {
                if (typeof aField === 'string') {
                    if(aField.toLowerCase() > bField.toLowerCase()) return -1;
                    if(aField.toLowerCase() < bField.toLowerCase()) return 1;
                    return 0;
                }
                return bField - aField;  
            } else {
                if (typeof aField === 'string') {
                    if(aField.toLowerCase() < bField.toLowerCase()) return -1;
                    if(aField.toLowerCase() > bField.toLowerCase()) return 1;
                    return 0;
                }
                return aField - bField;                                                        
            }
        }).flatMap(([firstKey, firstData]) => {
            if (!isRenderFirstLvl && !isRenderSecondLvl) {
                return {
                    'Тип и уровень': firstKey,
                    'Кол-во операций': firstData.count,
                    'Сумма': firstData.totalSum
                };
            }

            if (isRenderFirstLvl && !isRenderSecondLvl) {
                return Object.entries(firstData.detailData).flatMap(([secondKey, secondData]) => {    
                    return {
                        'Филиал': firstKey,
                        'Тип и уровень': secondKey,
                        'Кол-во операций': secondData.count,
                        'Сумма': secondData.totalSum
                    };
                });
            }

            if (isRenderFirstLvl && isRenderSecondLvl) {
                return Object.entries(firstData.detailData).flatMap(([secondKey, secondData]) => {
                    return Object.entries(secondData.detailData).flatMap(([lastKey, lastData]) => {
                        const dateText = firstLvl === 'day' ? 'Дата' : 'Период';

                        return {
                            'Филиал': firstKey,
                            [dateText]: secondKey,
                            'Тип и уровень': lastKey,
                            'Кол-во операций': lastData.count,
                            'Сумма': lastData.totalSum
                        };
                    });
                });
            }

            if (!isRenderFirstLvl && isRenderSecondLvl) {
                return Object.entries(firstData.detailData).flatMap(([secondKey, secondData]) => {
                    const dateText = firstLvl === 'day' ? 'Дата' : 'Период';
    
                    return {
                        [dateText]: firstKey,
                        'Тип и уровень': secondKey,
                        'Кол-во операций': secondData.count,
                        'Сумма': secondData.totalSum
                    };
                });
            }
        });

        const result = Object.values(data).reduce((acc, item) => {
            acc.totalSum += item.totalSum || 0;
            acc.count += item.count || 0;
            return acc;
        }, { totalSum: 0, count: 0 });

        let textRes = 'Тип и уровень';
        if (isRenderFirstLvl) textRes = 'Филиал';
        if (!isRenderFirstLvl && isRenderSecondLvl) {
            const dateText = firstLvl === 'day' ? 'Дата' : 'Период';
            textRes = dateText;
        }

        exportData.push({
            [textRes]: 'ИТОГО',
            'Кол-во операций': result.count,
            'Сумма': result.totalSum
        });

        const ws = utils.json_to_sheet(exportData);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, 'Бонусные баллы');
        const dopText = [];
        const periodText = `${moment(renderFilters.created_at_gte).format('DD.MM.YYYY')} - ${moment(renderFilters.created_at_lte).format('DD.MM.YYYY')}`;
        dopText.push(periodText);
        const typeText = (renderFilters.type && renderFilters.type !== 'all') ? renderFilters.type === 'setBalance' ? 'Начисления' : 'Cписания' : null;
        if (typeText) dopText.push(typeText);
        if (isRenderFirstLvl) dopText.push(`Детализация 1 - ${renderDetail.firstLvl.label || '-'}`);
        if (isRenderSecondLvl) dopText.push(`Детализация 2 - ${renderDetail.secondLvl.label || '-'}`);
        const resultText = dopText.join(', ');
        writeFileXLSX(wb, `Отчет о начислении бонусных баллов ${resultText}.xlsx`);
    }

    const renderHead = () => {
        return(
            <div className="kt-portlet__head" style={{ flexDirection: 'column', gap: '10px' }}>
                <div className="kt-portlet__head-label">
                    <h3 className="kt-portlet__head-title">
                        Начисление бонусных баллов (ст.лог)
                    </h3>
                </div>
                <div className='kt-separator kt-separator--border-dashed kt-separator--space-sm'/>
                <div><h6 style={{ color: 'black'}}> Поиск </h6></div>
                <div className="kt-portlet__head-toolbar" style={{ flexWrap: 'wrap', gap: '10px' }}>
                    <div style={{ width: 200 }}>
                        <label>Период *</label>
                        <DateSelect 
                        isDisabled={loading}
                        isLoading={loading}
                        optionsDate={{
                            tommorow: true,
                            period: true,
                            prevWeek: true,
                            prevMonth: true,
                        }}
                        limit={{ 
                            field: 'months',
                            value: 6
                        }}
                        width={200}
                        onChange={onChangeDateSelect}
                        />
                    </div>
                    <div>
                        <label>Города *</label>
                        <MultiSelect data={cities.map((city) => ({ label: city.name, value: city.id }))} width={200} placeholder='Города' values={filters.cities} setData={setFilters('cities')} loading={loading || citiesLoading} disabled={loading || citiesLoading}/>
                    </div>
                    <div style={{ width: 200 }}>
                        <label>Ступени *</label>
                        <MultiSelect 
                            data={[
                                { label: 'Уровень 1', value: 'level1' },
                                { label: 'Уровень 2', value: 'level2' },
                                { label: 'Уровень 3', value: 'level3' },
                                { label: 'Уровень 4', value: 'level4' },
                            ]} 
                            width={200}
                            placeholder='Ступени'
                            values={filters.lvls}
                            setData={setFilters('lvls')}
                            loading={loading} 
                            disabled={loading}
                        />
                    </div>
                    <div style={{ width: 200 }}>
                        <label>Тип *</label>
                        <Select
                            closeMenuOnSelect={true}
                            options={[
                                { label: 'Все типы', value: 'all'},
                                { label: 'Начисление', value: 'setBalance' },
                                { label: 'Списание', value: 'minusBalance' },
                            ]}
                            onChange={setFilters('type')}
                            placeholder="Тип 1"
                            noOptionsMessage={() => 'Нет'}
                            value={filters.type}                   
                        />
                    </div>
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <button disabled={isDisabledSearch()} onClick={onSearch} style={{ marginTop: '1.9rem' }} className="btn btn-primary">Найти</button>
                        {renderData() && <button disabled={loading} onClick={onExport} style={{ marginTop: '1.9rem' }} className='btn btn-dark btn-icon-sm'>Экспорт</button>}
                    </div>
                </div>
                <div className='kt-separator kt-separator--border-dashed kt-separator--space-sm'/>
                <div><h6 style={{ color: 'black'}}> Детализация </h6></div>
                <div className="kt-portlet__head-toolbar" style={{ flexWrap: 'wrap', gap: '10px' }}>
                    <div style={{ width: 200 }}>
                        <label>Уровень 1</label>
                        <Select
                            closeMenuOnSelect={true}
                            options={secondLvlOptions}
                            onChange={setDetail('firstLvl')}
                            placeholder="Уровень 1"
                            noOptionsMessage={() => 'Нет'}
                            value={renderDetail.firstLvl}                   
                        />
                    </div>
                    <div style={{ width: 200 }}>
                        <label>Уровень 2</label>
                        <Select
                            closeMenuOnSelect={true}
                            options={getSecondLvlOptions()}
                            onChange={setDetail('secondLvl')}
                            placeholder="Уровень 2"
                            noOptionsMessage={() => 'Нет'}
                            value={renderDetail.secondLvl}                   
                        />
                    </div>
                </div>
            </div>
        );
    }

    const renderAdressLog = (log) => {
        if (log.order) {
            if (log.order.point) {
                let point = log.order.point;
                if (!point.id || !point.city || !point.city.name) point = points.find((p) => p.id === point);
                const cityName = point.city && point.city.name ? point.city.name : null;
                return `${cityName ? cityName : '---'}, ${point.street}, ${point.house}`;
            }

            if (log.order.zone && log.order.zone.point) {
                let point = log.order.zone.point;
                if (!point.id || !point.city || !point.city.name) point = points.find((p) => p.id === point);
                const cityName = point.city && point.city.name ? point.city.name : null;
                return `${cityName ? cityName : '---'}, ${point.street}, ${point.house}`;
            }
        }
        
        if (log.user) {
            if (log.user.points && log.user.points.length > 0) {
                const entityPoints = log.user.points.map((logPoint) => {
                    let point = logPoint;
                    if (!point.id || !point.city || !point.city.id || !point.city.name) point = points.find((p) => p.id === point);
                    const values = renderFilters.cities.map((item) => item.value);
                    if (values.includes(point.city.id)) return point;
                    return null;
                }).filter((item) => item);

                if (entityPoints && entityPoints.length > 0) {
                    const point = entityPoints[0];
                    const cityName = point.city && point.city.name ? point.city.name : null;
                    return `${cityName ? cityName : '---'}, ${point.street}, ${point.house}`;
                }
            }
        }
        
        return 'Не определен'
    }    

    const getGroupedData = () => {
        const firstLvl = renderDetail.firstLvl.value;
        const secondLvl = renderDetail.secondLvl.value;
        
        const baseLvlKeys = [
            {value: 'level1', type: 'setBalance', key: 'Начисление ур. 1'},
            {value: 'level2', type: 'setBalance', key: 'Начисление ур. 2'},
            {value: 'level3', type: 'setBalance', key: 'Начисление ур. 3'},
            {value: 'level4', type: 'setBalance', key: 'Начисление ур. 4'},
            {value: 'level1', type: 'minusBalance', key: 'Списание ур. 1'},
            {value: 'level2', type: 'minusBalance', key: 'Списание ур. 2'},
            {value: 'level3', type: 'minusBalance', key: 'Списание ур. 3'},
            {value: 'level4', type: 'minusBalance', key: 'Списание ур. 4'},
        ].filter((itemBase) => {
            if (renderFilters.lvls && renderFilters.lvls.length > 0) {
                const values = renderFilters.lvls.map((item) => item.value);
                if (values.includes(itemBase.value)) return true;
                return false;
            }
            return true
        })
        .filter((itemBase) => {
            if (renderFilters.type && renderFilters.type.value !== 'all') {
                if (renderFilters.type.value === itemBase.type) return true;
                return false;
            }
            return true;
        });
    
        const getFirstKeys = () => {
            if (firstLvl === 'none') return [];
            const keys = new Set();

            if (renderFilters.cities && renderFilters.cities.length > 0) {
                return renderFilters.cities.flatMap((city) => {
                    if (!city || !city.value) return null;
                    const entityPoints = points.filter((point) => point.city.id === city.value);
                    return [...entityPoints.map((point) => renderAdressPoint(point)), 'Не определен'];
                })
            } else {
                result.forEach((log) => {
                    let key = renderAdressLog(log);

                    if (key) return keys.add(key);
                    keys.add('Филиал не задан');
                });
            }
            
            return Array.from(keys);
        };
    
        const getDateKeys = () => {
            if (secondLvl === 'none') return [];
            
            const startDate = moment(renderFilters.created_at_gte);
            const endDate = moment(renderFilters.created_at_lte);
            const dateKeys = [];

            switch (secondLvl) {
                case 'day': {
                    let current = startDate.clone();
                    while (current <= endDate) {
                        dateKeys.push(current.format('DD.MM.YYYY'));
                        current.add(1, 'day');
                    }
                    break;
                }
                case 'week': {
                    let current = startDate.clone().startOf('isoWeek');
                    let end = endDate.clone().endOf('isoWeek');
                    
                    while (current <= end) {
                        let weekStart = current;
                        let weekEnd = current.clone().endOf('isoWeek');
        
                        if (weekStart < startDate) {
                            weekStart = startDate.format('DD.MM.YYYY');
                        } else {
                            weekStart = weekStart.format('DD.MM.YYYY');
                        }
                        
                        if (weekEnd > endDate) {
                            weekEnd = endDate.format('DD.MM.YYYY');
                        } else {
                            weekEnd = weekEnd.format('DD.MM.YYYY');
                        }
                        
                        dateKeys.push(`${weekStart} - ${weekEnd}`);
                        current.add(1, 'week');
                    }
                    break;
                }
                case 'month': {
                    let current = startDate.clone().startOf('month');
                    let end = endDate.clone().endOf('month');
                    
                    while (current <= end) {
                        const monthStart = current.format('DD.MM.YYYY');
                        const monthEnd = current.clone().endOf('month').format('DD.MM.YYYY');
                        dateKeys.push(`${monthStart} - ${monthEnd}`);
                        current.add(1, 'month');
                    }
                    break;
                }
                default: break;
            }
            
            return dateKeys;
        };
    
        const createData = () => {
            const firstKeys = getFirstKeys();
            const dateKeys = getDateKeys();
            
            const data = {};

            if (firstLvl !== 'none') {
                firstKeys.forEach((firstKey) => {
                    const firstData = {
                        name: firstKey,
                        totalSum: 0,
                        count: 0,
                        detailData: {},
                        items: [],
                    };
                    
                    if (secondLvl !== 'none') {
                        dateKeys.forEach(dateKey => {
                            const dateData = {
                                name: dateKey,
                                totalSum: 0,
                                count: 0,
                                detailData: {},
                                items: [],
                            };
                            
                            baseLvlKeys.forEach((baseKey) => {
                                const baseData = {
                                    name: baseKey.key,
                                    totalSum: 0,
                                    count: 0,
                                    detailData: {},
                                    items: [],
                                };
                                dateData.detailData[baseKey.key] = baseData;
                            });
                            
                            firstData.detailData[dateKey] = dateData;
                        });
                    } else {
                        baseLvlKeys.forEach((baseKey) => {
                            const baseData = {
                                name: baseKey.key,
                                totalSum: 0,
                                count: 0,
                                detailData: {},
                                items: [],
                            };
                            firstData.detailData[baseKey.key] = baseData;
                        });
                    }
                    
                    data[firstKey] = firstData;
                });
            } else if (secondLvl !== 'none') {
                dateKeys.forEach(dateKey => {
                    const dateData = {
                        name: dateKey,
                        totalSum: 0,
                        count: 0,
                        detailData: {},
                        items: [],
                    };
                    
                    baseLvlKeys.forEach((baseKey) => {
                        const baseData = {
                            name: baseKey.key,
                            totalSum: 0,
                            count: 0,
                            detailData: {},
                            items: [],
                        };
                        dateData.detailData[baseKey.key] = baseData;
                    });
                    
                    data[dateKey] = dateData;
                });
            } else {
                baseLvlKeys.forEach((baseKey) => {
                    const baseData = {
                        name: baseKey.key,
                        totalSum: 0,
                        count: 0,
                        detailData: {},
                        items: [],
                    };
                    data[baseKey.key] = baseData;
                });
            }
            
            return data;
        };
        
        const getDateKeyLogs = (log) => {
            const logDate =  moment(log.created_at);
            
            switch(secondLvl) {
                case 'day': {
                    return logDate.format('DD.MM.YYYY');
                }
                case 'week': {
                    const startDate = moment(renderFilters.created_at_gte);
                    const endDate = moment(renderFilters.created_at_lte);
                    let weekStart = logDate.clone().startOf('isoWeek');
                    let weekEnd = logDate.clone().endOf('isoWeek');
    
                    if (weekStart < startDate) {
                        weekStart = startDate.format('DD.MM.YYYY');
                    } else {
                        weekStart = weekStart.format('DD.MM.YYYY');
                    }
                
                    if (weekEnd > endDate) {
                        weekEnd = endDate.format('DD.MM.YYYY');
                    } else {
                        weekEnd = weekEnd.format('DD.MM.YYYY');
                    }
                    
                    return `${weekStart} - ${weekEnd}`;
                }
                case 'month': {
                    const monthStart = logDate.startOf('month').format('DD.MM.YYYY');
                    const monthEnd = logDate.endOf('month').format('DD.MM.YYYY');
                    return `${monthStart} - ${monthEnd}`;
                }
                default: {
                    return null;
                }
            }
        };
    
        const fillNullData = (data) => {
            const updated = JSON.parse(JSON.stringify(data));
            
            (result || []).forEach((log) => {
                const totalPrice = parseFloat(log.balance) || 0;
                const firstKey = renderAdressLog(log);   
                const dateKey = getDateKeyLogs(log);
                const baseKeyData = baseLvlKeys.find((itemBase) => itemBase.value === log.cashbackLevel && itemBase.type === log.operationType);
                const baseKey = (baseKeyData && baseKeyData.key) ? baseKeyData.key : 'Уровень и тип не определены';

                if (firstLvl !== 'none') {
                    if (firstKey && updated[firstKey]) {
                        const firstData = updated[firstKey];
                        firstData.totalSum = parseNumToFixed((parseFloat(updated[firstKey].totalSum) || 0) + totalPrice);
                        firstData.count += 1;
                    
                        if (secondLvl !== 'none') {
                            if (dateKey && firstData.detailData[dateKey]) {
                                const dateData = firstData.detailData[dateKey];
                                dateData.totalSum = parseNumToFixed((parseFloat(dateData.totalSum) || 0) + totalPrice);
                                dateData.count += 1;
                                dateData.items.push(log);
                                const baseData = dateData.detailData[baseKey];
                                baseData.totalSum = parseNumToFixed((parseFloat(baseData.totalSum) || 0) + totalPrice);
                                baseData.count += 1;
                                baseData.items.push(log);
                            }
                        } else {
                            const baseData = firstData.detailData[baseKey];
                            baseData.totalSum = parseNumToFixed((parseFloat(baseData.totalSum) || 0) + totalPrice);
                            baseData.count += 1;
                            baseData.items.push(log);
                        }
                    }
                } else if (secondLvl !== 'none') {
                    if (dateKey && updated[dateKey]) {
                        const dateData = updated[dateKey];
                        dateData.totalSum = parseNumToFixed((parseFloat(dateData.totalSum) || 0) + totalPrice);
                        dateData.count += 1;
                        dateData.items.push(log);
                        const baseData = dateData.detailData[baseKey];
                        baseData.totalSum = parseNumToFixed((parseFloat(baseData.totalSum) || 0) + totalPrice);
                        baseData.count += 1;
                        baseData.items.push(log);
                    }
                } else {
                    const baseData = updated[baseKey];
                    baseData.totalSum = parseNumToFixed((parseFloat(baseData.totalSum) || 0) + totalPrice);
                    baseData.count += 1;
                    baseData.items.push(log);
                }
            });
            
            return updated;
        };
    
        const data = createData();

        const filledData = fillNullData(data);

        return filledData;
    };

    const renderTable = () => {
        const { field, sort } = _sort;
        const firstLvl = renderDetail.firstLvl.value;
        const secondLvl = renderDetail.secondLvl.value;
        const data = getGroupedData();

        return(
            <div className='kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded'>
                <table className='kt-datatable__table' style={{ width: '100%'}}>
                    <thead className='kt-datatable__head' style={{ position: 'sticky' }}>
                        <tr className='kt-datatable__row'>
                            <th className='kt-datatable__cell' style={{ width: 'auto' }}>
                                <SortButton 
                                className={field === 'name' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} 
                                text='Наименование' onClick={() => handleClickSort('name')} 
                                up={field === 'name' && sort === 'ASC'}
                                />
                            </th>
                            <th className='kt-datatable__cell' style={{ width: '140px' }}>
                                <SortButton 
                                className={field === 'count' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} 
                                text='Кол-во операций' 
                                onClick={() => handleClickSort('count')} 
                                up={field === 'count' && sort === 'ASC'}
                                />
                            </th>
                            <th className='kt-datatable__cell' style={{ width: '140px' }}>
                            <SortButton 
                                className={field === 'totalSum' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} 
                                text='Сумма' 
                                onClick={() => handleClickSort('totalSum')} 
                                up={field === 'totalSum' && sort === 'ASC'}
                                />
                            </th>
                        </tr>
                    </thead>
                    <tbody className='kt-datatable__body'>
                        {Object.entries(data)
                        .sort(([aKey, a], [bKey, b]) => {
                            const { field, sort } = _sort;
                            const aField = a[field || 'name'];
                            const bField = b[field || 'name'];
                            if (sort === 'DESC') {
                                if (typeof aField === 'string') {
                                    if(aField.toLowerCase() > bField.toLowerCase()) return -1;
                                    if(aField.toLowerCase() < bField.toLowerCase()) return 1;
                                    return 0;
                                }
                                return bField - aField;  
                            } else {
                                if (typeof aField === 'string') {
                                    if(aField.toLowerCase() < bField.toLowerCase()) return -1;
                                    if(aField.toLowerCase() > bField.toLowerCase()) return 1;
                                    return 0;
                                }
                                return aField - bField;                                                        
                            }
                        })
                        .map(([key, item]) => <ItemRow item={item} firstLvl={firstLvl} secondLvl={secondLvl}/>)}
                        <ResultRow items={data} />
                    </tbody>
                </table>
            </div>
        );
    }

    const renderData = () => {
        if (!renderFilters.lvls || renderFilters.lvls.length === 0) return false;
        if ((!result || result.length === 0) && (!renderFilters.cities || renderFilters.cities.length === 0)) return false;
        return true;       
    }

    const renderBody = () => {
        if (loading || pointLoading) return <div style={styles.loading}><Loader /></div>;        

        if (!renderData()) return <div className='kt-portlet'> 
            <div className='kt-portlet__body'>Нет данных</div> 
        </div>

        return(
        <div className="kt-portlet">
            <ErrorContainer field="cashback" style={{ margin: '20px 20px 0px 20px' }} hasCloseButton={true}/>
            <div className='kt-portlet__body'>
            {renderTable()}    
            </div> 
        </div>
        );
    }

    return (
        <>
            <div className="kt-portlet">
                {renderHead()}
            </div>
            {renderBody()}
        </>         
    );
}